import { z } from 'zod/v4-mini';
import { ZodTaskDescription } from './TaskDescription.js';
import { matchingZodObject } from '../utilities/matchingZodObject.js';
export const ZodTaskList = matchingZodObject({
    tasks: z.array(ZodTaskDescription),
});
//# sourceMappingURL=TaskList.js.map